<app-alert type="info">
  <ng-container alert-title>
    {{ details.title | customLocale }}
  </ng-container>
  <ng-container alert-body>
    <div>{{ details.text | customLocale }}</div>
  </ng-container>
  <ng-container alert-buttons>
    <on-ui-button
      class="primary outline"
      [label]="details.cancel"
      (onclick)="onClose()">
    </on-ui-button>
    <on-ui-button
      class="primary"
      [label]="details.submit"
      (onclick)="onSave()">
    </on-ui-button>
  </ng-container>
</app-alert>
